import { render, staticRenderFns } from "./EditTripJson.vue?vue&type=template&id=31af7d70&scoped=true&"
import script from "./EditTripJson.vue?vue&type=script&lang=js&"
export * from "./EditTripJson.vue?vue&type=script&lang=js&"
import style0 from "./EditTripJson.vue?vue&type=style&index=0&id=31af7d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af7d70",
  null
  
)

/* custom blocks */
import block0 from "./EditTripJson.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports